import type { CreateLutDto, GetLutsDto, LutCreatedDto } from "@mimir/common/dto/lutDtos";
import type { BackendClient } from "@mimir/common/util/backendClient";
import { apiDelete, apiGet, apiPost, apiPut } from "@mimir/common/util/http";
import { ofCompleteLut, ofDeleteLut, ofLuts } from "@mimir/common/aws/api/path";
import { assumeResultObject } from "@mimir/common/client/assumeResult";

export async function api_createLut(c: BackendClient, dto: CreateLutDto): Promise<LutCreatedDto> {
  return await apiPost(c.getApiClient(), ofLuts(c.getServiceLinks()), dto)
    .then(result => assumeResultObject<LutCreatedDto>(result));
}

export async function api_completeLut(c: BackendClient, id: string): Promise<void> {
  await apiPut(c.getApiClient(), ofCompleteLut(c.getServiceLinks(), id));
}

export async function api_getLuts(c: BackendClient): Promise<GetLutsDto> {
  return await apiGet(c.getApiClient(), ofLuts(c.getServiceLinks()))
    .then(result => assumeResultObject<GetLutsDto>(result));
}

export async function api_deleteLut(c: BackendClient, id: string): Promise<void> {
  await apiDelete(c.getApiClient(), ofDeleteLut(c.getServiceLinks(), id));
}
